// extracted by mini-css-extract-plugin
export default {"userBox":"user_userBox__zZrzs","paramsBox":"user_paramsBox__CfYOG","btnBox":"user_btnBox__dpn8p"};